import { PopupRequest } from "@azure/msal-browser";

export interface BlobContainerConfig {
  accountName: string;
  endpointSuffix: string;
  blobContainer: string;
}

export const msalConfig = {
  auth: {
    tenantId: window.portalTenantId,
    clientId: window.portalAadClientId,
    authority: "https://login.microsoftonline.com/" + window.portalTenantId, // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
};
export const loginRequest: PopupRequest = {
  scopes: ["User.Read"],
};
